import { createContext, useState } from 'react';

export const LayoutContext = createContext();

export function LayoutContextProvider({ children }) {
  const [layoutStyle, setLayoutStyle] = useState({});
  // ...
  return (
    <LayoutContext.Provider value={{layoutStyle, setLayoutStyle}}>
      {children}
    </LayoutContext.Provider>
  );
}